module.exports = "/_next/static/resources/photo-3-01ea930c3a916ba7672506c5ace0306e.jpg";